"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import WebBrainLeftSidebarWaves from "./WebBrainLeftSidebarWaves";
import WebDirectMessagesList from "./WebDirectMessagesList";
import { usePathname } from "next/navigation";

/**
 * WebLeftSidebar
 *
 * Web‑specific left sidebar content. Chooses between Waves and Direct Messages
 * sections based on the current pathname ("/messages" routes show DMs).
 *
 * Rendering
 * - Uses an internal scroll container to enable inertia scrolling and custom
 *   scrollbars without managing explicit heights; relies on parent layout flex.
 */
interface WebLeftSidebarProps {
  readonly isCollapsed?: boolean;
}
const WebLeftSidebar: React.FC<WebLeftSidebarProps> = t0 => {
  const $ = _c(16);
  const {
    isCollapsed: t1
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  const scrollContainerRef = useRef(null);
  const pathname = usePathname();
  let t2;
  if ($[0] !== pathname) {
    t2 = pathname?.startsWith("/messages");
    $[0] = pathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isMessagesView = t2;
  const t3 = `tw-relative tw-w-full tw-h-full ${isCollapsed ? "lg:tw-w-16" : "lg:tw-w-80"}`;
  const t4 = `tw-flex tw-flex-col tw-border-b-0 tw-border-iron-700/95 tw-border-solid tw-border-l-0 tw-border-t-0 tw-border-r tw-overflow-y-auto tw-w-full tw-h-full tw-scrollbar-thin no-scrollbar tw-scrollbar-thumb-iron-500 tw-transition-colors tw-duration-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-overflow-x-hidden tw-z-40 ${isCollapsed ? "lg:tw-w-16" : "lg:tw-w-80"}`;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      minHeight: "100%"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== isCollapsed || $[4] !== isMessagesView) {
    t6 = !isMessagesView && <WebBrainLeftSidebarWaves scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} />;
    $[3] = isCollapsed;
    $[4] = isMessagesView;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isCollapsed || $[7] !== isMessagesView) {
    t7 = isMessagesView && <WebDirectMessagesList scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} />;
    $[6] = isCollapsed;
    $[7] = isMessagesView;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div ref={scrollContainerRef} className={t4} style={t5}>{t6}{t7}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[13] = t3;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default WebLeftSidebar;